import type { MessageCatalog } from "../types";

const sourceSand = "\u2066SOURCE / SAND\u2069";
const b2b = "\u2066B2B\u2069";
const cloudflareD1 = "\u2066Cloudflare D1\u2069";

export const ru = {
  language: {
    selectorLabel: "Язык"
  },
  brand: {
    homeLabel: "Главная SOURCE / SAND"
  },
  nav: {
    primaryLabel: "Основная навигация",
    mobileLabel: "Мобильная навигация",
    open: "Открыть навигацию",
    close: "Закрыть навигацию",
    water: "О воде",
    journey: "Путь",
    journal: "Журнал",
    join: "Записаться на дегустацию"
  },
  metadata: {
    home: {
      title: "SOURCE / SAND — из Борсека в Дубай",
      description:
        "Независимое исследование рынка Дубая о более доступных поставках природной минеральной воды Borsec из Румынии."
    },
    journal: {
      title: "Вода из источника — SOURCE / SAND",
      description:
        "Материалы с источниками о минеральной воде, румынском происхождении, водной системе Дубая и практическом пути импорта."
    },
    article: {
      title: "Материал о воде — SOURCE / SAND",
      description:
        `Материал ${sourceSand} со ссылками на источники: о воде, вкусе, происхождении или импорте.`
    },
    research: {
      title: "Исследование и критерии решения — SOURCE / SAND",
      description:
        "Источники, рыночные данные, правила формулировок и критерии решения для теста поставок Borsec в Дубай."
    },
    privacy: {
      title: "Конфиденциальность — SOURCE / SAND",
      description:
        `Как ${sourceSand} обрабатывает ответы в исследовании рынка и согласия на электронные письма.`
    },
    notFound: {
      title: "Страница не найдена — SOURCE / SAND",
      description:
        "Независимое исследование рынка Дубая о более доступных поставках природной минеральной воды Borsec из Румынии."
    }
  },
  dates: {
    unavailable: "Дата недоступна",
    lastUpdated: "Последнее обновление"
  },
  hero: {
    title: "Настоящая минеральная вода — из Карпат в Дубай.",
    lede:
      "Мы выясняем, нужен ли Дубаю более простой и надёжный доступ к Borsec — природной минеральной воде из Румынии — в форматах и по ценам, которые люди действительно готовы выбирать.",
    primaryAction: "Я бы это пил",
    secondaryAction: "Что содержится в воде",
    imageAlt:
      "Визуализация холодной бутылки Borsec между карпатским ручьём и песчаными дюнами",
    imageCaption: "Визуализация продукта для исследования рынка",
    independent: "Независимое исследование рынка",
    disclosure: "Проект не связан с Borsec или Romaqua Group и не одобрен ими"
  },
  water: {
    introTitle: "Вода с определённым местом происхождения.",
    introBody:
      "Муниципальная вода Дубая опресняется и обрабатывается по строгим нормам питьевой воды. Природная минеральная вода — другое предложение: растворённые минералы и характер она получает из конкретного подземного источника.",
    desalinationFactLabel: "Факт об опреснении воды в Дубае",
    statUnit: "миллионов имперских галлонов в сутки",
    statBody: "Установленная мощность опреснения в Дубае в 2025 году.",
    dewaReport: "Отчёт DEWA об устойчивом развитии за 2025 год",
    dubaiPathTitle: "Вода Дубая",
    dubaiPath: ["Море", "Опреснение", "Обработка", "Сеть"],
    borsecPathTitle: "Минеральная вода Borsec",
    borsecPath: ["Дождь и снег", "Карпатская порода", "Подземный источник", "Розлив у источника"],
    originNote:
      "Это выбор вкуса и происхождения, а не утверждение о небезопасности воды Дубая. DEWA сообщает, что её питьевая вода отвечает действующим требованиям Всемирной организации здравоохранения.",
    mineralsTitle: "Читайте этикетку, а не громкие обещания.",
    mineralsBody:
      "Технический лист 2024 года для природно-газированной воды Borsec приводит состав ниже. Точные значения зависят от источника и конкретного товара; окончательным ориентиром должна быть этикетка, зарегистрированная в ОАЭ.",
    mineralAnalysisLabel: "Минеральный состав Borsec",
    mineralLabels: {
      Bicarbonate: "Гидрокарбонат",
      Calcium: "Кальций",
      Magnesium: "Магний",
      Sodium: "Натрий"
    },
    sourceNote:
      "Технический лист природно-газированной Borsec, редакция от 8 апреля 2024 года. Состав следует сверить с конкретным продуктом, одобренным для ОАЭ.",
    sourceLink: "Подробнее об источнике Borsec",
    imageAlt: "Стакан газированной минеральной воды на мокром камне у ручья"
  },
  journey: {
    title: "Один источник. Долгий путь до вашего холодильника.",
    body:
      "Поставка может начаться в Борсеке, пересечь Европу до порта, пройти через Суэцкий маршрут и прибыть в Джебель-Али. Прежде чем отправлять хотя бы одну палету, мы хотим понять, что Дубай действительно будет покупать.",
    mapLabel: "Условный маршрут из Борсека в Дубай",
    mapTitle: "Условный маршрут из Борсека через Констанцу и Суэц в Джебель-Али",
    stops: [
      { name: "Борсек", detail: "Харгита, Румыния" },
      { name: "Констанца", detail: "Условный порт" },
      { name: "Суэц", detail: "Морской путь" },
      { name: "Джебель-Али", detail: "Дубай, ОАЭ" }
    ],
    routeNote: "Условный маршрут · логистика и выбор портов ещё не подтверждены",
    signalCount: "4 сигнала",
    signalSummary: "Формат, цена, интерес к дегустации и намерение покупать снова.",
    demandTitle: "Маршрут представить можно. Спрос ещё предстоит доказать.",
    demandBody:
      "До отправки палеты тест должен показать, что люди готовы заказывать, какие форматы предпочитают, какая цена с доставкой кажется оправданной и превратится ли интерес в повторную покупку.",
    addSignal: "Добавить свой сигнал",
    sourceNote: "Независимое исследование спроса · без заказов и оплаты"
  },
  validation: {
    title: "Помогите создать более удобный способ покупки.",
    lede:
      "Расскажите, что вы действительно заказали бы. Без оплаты и спама — только сигнал точнее, чем отметка «нравится».",
    measuresTitle: "Что мы измерим",
    measures: ["Подтверждённый интерес", "Принятие цены", "Предпочтительный формат", "Повторное намерение"],
    usefulSignalTitle: "Какой сигнал действительно полезен?",
    usefulSignalBody:
      "Реакция на реальную цену, запрос на дегустацию и намерение покупать снова важнее роста рассылки. Действующих покупателей Borsec и тех, кто пробует её впервые, мы оценим отдельно."
  },
  interestForm: {
    legends: {
      buyer: "Покупаю для",
      familiarity: "Мой опыт с Borsec",
      water: "Моя Borsec",
      format: "Предпочтительная упаковка",
      priceBefore: "Оформили бы вы предзаказ на упаковку ",
      priceBetween: " за ",
      priceAfter: "?",
      frequency: "Как часто она вам подходит?"
    },
    options: {
      buyer: [
        { value: "home", label: "Дома" },
        { value: "office", label: "Офиса" },
        { value: "hospitality", label: "Ресторана / отеля" },
        { value: "retail", label: "Розницы" }
      ],
      familiarity: [
        { value: "regular", label: "Уже покупаю" },
        { value: "tried", label: "Пробовал(а)" },
        { value: "aware", label: "Знаю название" },
        { value: "new", label: "Впервые слышу" }
      ],
      water: [
        { value: "sparkling", label: "Газированная" },
        { value: "still", label: "Негазированная" },
        { value: "both", label: "Обе" }
      ],
      format: [
        { value: "glass", label: "Стекло" },
        { value: "pet", label: "ПЭТ" },
        { value: "either", label: "Любой" }
      ],
      price: [
        { value: "yes", label: "Да" },
        { value: "maybe", label: "Возможно" },
        { value: "no", label: "Не по этой цене" }
      ],
      frequency: [
        { value: "weekly", label: "Еженедельно" },
        { value: "monthly", label: "Ежемесячно" },
        { value: "occasionally", label: "Иногда" },
        { value: "tasting", label: "Сначала попробую" }
      ]
    },
    priceQualifier:
      "Гипотетическая проверка цены прямой доставки. Формат, итоговая стоимость и наличие ещё не подтверждены.",
    email: "Электронная почта",
    emailPlaceholder: "name@example.com",
    area: "Район Дубая",
    optional: "необязательно",
    areaPlaceholder: "например, Марина",
    contactConsent: "Пишите мне о дегустациях, наличии и этом исследовании рынка.",
    marketingConsent: `Также иногда присылайте мне материалы ${sourceSand} о воде. Необязательно.`,
    saving: "Сохраняем ваш ответ…",
    submit: "Записаться на дегустацию",
    footnote: "Независимое исследование рынка · сегодня без заказов и оплаты.",
    successTitle: "Вы в списке на дегустацию.",
    successBody:
      "Спасибо. Ваш выбор формата и цены поможет оценить смысл реального пилота. Мы будем писать только в пределах выбранных вами разрешений.",
    successAction: "Читать материалы о воде",
    errors: {
      verificationExpired: "Срок проверки истёк. Пройдите её ещё раз.",
      verificationLoad: "Не удалось загрузить проверку. Проверьте соединение и повторите.",
      verificationMisconfigured:
        "Форма интереса временно недоступна, пока настраивается проверка.",
      emailRequired:
        "Добавьте электронную почту, чтобы мы могли связаться с вами по поводу исследования.",
      emailInvalid: "Введите действительный адрес электронной почты и повторите.",
      consentRequired: "Подтвердите, что мы можем связаться с вами по поводу исследования.",
      verificationRequired: "Завершите проверку и повторите попытку.",
      verificationFailed: "Проверка не пройдена. Обновите страницу и повторите.",
      saveFailed: "Не удалось сохранить ответ. Повторите через несколько минут.",
      network: "Не удалось связаться с сервисом исследования. Проверьте соединение и повторите.",
      invalidRequest: "Некоторые данные формы не приняты. Проверьте их и повторите.",
      conflict: "Ответ изменился после отправки. Обновите страницу и повторите."
    }
  },
  faq: {
    title: "Честные ответы.",
    items: [
      {
        question: "Что произойдёт, если интерес подтвердится?",
        answer:
          "По результатам мы решим, стоит ли проводить дегустации, обсуждать поставки, проверять импортные требования и запускать соответствующий нормам пилот. Сейчас мы не принимаем заказы и оплату."
      },
      {
        question: "Вы связаны с Borsec?",
        answer:
          `Нет. ${sourceSand} — независимый проект проверки рынка, и сегодня у него нет дистрибьюторского соглашения.`
      },
      {
        question: "Вы принимаете заказы?",
        answer:
          "Пока нет. До любого коммерческого шага мы собираем подтверждённый интерес и запросы на дегустацию."
      },
      {
        question: "Вода Дубая небезопасна?",
        answer:
          "Нет. DEWA сообщает, что её питьевая вода отвечает действующим требованиям Всемирной организации здравоохранения. Этот проект — о вкусе и происхождении источника."
      }
    ]
  },
  finalCta: {
    title: "Нашлось бы для неё место в холодильнике?",
    body:
      "Уделите нам две минуты. Ваш выбор формата и цены, а также намерение купить определят, будет ли проект продолжен.",
    join: "Записаться на дегустацию",
    trade: "Я закупщик для бизнеса"
  },
  footer: {
    navigationLabel: "Навигация в нижней части страницы",
    research: "Исследование",
    journal: "Журнал",
    privacy: "Конфиденциальность",
    contact: "Связаться",
    disclosure:
      "Независимое исследование рынка · Проект не связан с Borsec или Romaqua Group и не одобрен ими.",
    location: "Дубай, ОАЭ"
  },
  research: {
    title: "Что сделает проект реальным?",
    intro:
      "Не трафик и не комплименты. Нужен убедительный набор сигналов: вкус, принятие цены, повторное намерение, соответствующая требованиям поставка и рабочая экономика.",
    hypothesisLabel: "Рабочая гипотеза",
    hypothesisBody:
      "В Дубае может быть спрос на предложение Borsec с акцентом на происхождение — сначала среди диаспоры, в премиальной доставке домой и гостинично-ресторанном секторе.",
    gatesTitle: "Заранее согласованные критерии решения",
    gatesBody:
      "Это пороги проекта, а не внешние отраслевые ориентиры. Если задать их до кампании, привлекательный список ожидания не превратится сам по себе в бизнес-обоснование.",
    metrics: [
      {
        value: "1,000",
        label: "целевых сессий из ОАЭ",
        note: "достаточный охват, чтобы отличить реальную закономерность от трафика друзей и семьи"
      },
      {
        value: "150+",
        label: "полных ответов",
        note: "с отдельной отчётностью по действующим покупателям Borsec и новым участникам"
      },
      {
        value: "3%",
        label: "конверсии с высоким намерением",
        note: "запрос на дегустацию или резерв по жизнеспособной показанной цене, а не только адрес почты"
      },
      {
        value: "3",
        label: `письменных пилота ${b2b}`,
        note: "со сроками, форматом и ожидаемым месячным объёмом"
      }
    ],
    testTitle: "Что мы проверим",
    tests: [
      {
        title: "Вкус и происхождение",
        body: "Сможет ли Borsec выиграть выбор без запугивающих заявлений о местной воде?"
      },
      {
        title: "Реальные форматы",
        body: "Газированная или нет, стекло или ПЭТ, домашняя упаковка или бутылка для гостиниц и ресторанов."
      },
      {
        title: "Жизнеспособная цена",
        body: "Готовы ли люди подтвердить интерес, когда вопрос содержит реалистичную цену упаковки с доставкой?"
      },
      {
        title: "Повторное поведение",
        body: "Это ностальгия и любопытство — или еженедельная либо ежемесячная привычка?"
      }
    ],
    guardrailsTitle: "Чего мы не будем утверждать",
    guardrails: [
      "Никаких формулировок о большей безопасности, чистоте или превосходном увлажнении.",
      "Никаких медицинских заявлений, обещаний о пищеварении, детоксе или заболеваниях.",
      "Никаких намёков на небезопасность муниципальной воды Дубая.",
      "Никаких заявлений «впервые в ОАЭ» или искусственного дефицита.",
      "Никаких заявлений о полномочиях или дистрибуции без действующего соглашения.",
      "Никакого экологического ореола без измеренных данных о перевозке и упаковке."
    ],
    sourcesTitle: "Библиотека источников",
    sourcesBody:
      "Утверждения на сайте намеренно узкие и по возможности связаны с актуальными первичными или авторитетными источниками.",
    sources: [
      {
        label: "Перечень признанных природных минеральных вод ЕС, июнь 2026 года",
        href: "https://food.ec.europa.eu/document/download/ec4fbcc0-7185-4dce-820a-27f7e2653dad_en?filename=labelling-nutrition_mineral-waters_list_eu-recognised.pdf"
      },
      {
        label: "Romaqua Group: история и происхождение Borsec",
        href: "https://romaqua-group.ro/en/brands/borsec/"
      },
      {
        label: "Отчёт DEWA об устойчивом развитии за 2025 год",
        href: "https://www.dewa.gov.ae/-/media/Files/Sustainability/Sustainability_Report_English_2025.ashx"
      },
      {
        label: "Пищевые услуги муниципалитета Дубая",
        href: "https://www.dm.gov.ae/dubai-municipality-services/"
      },
      {
        label: "Опрос потребителей бутилированной воды в ОАЭ за 2022 год",
        href: "https://www.mdpi.com/2071-1050/14/5/2664"
      }
    ]
  },
  privacy: {
    title: "О конфиденциальности простыми словами.",
    lede:
      `${sourceSand} — независимый проект исследования рынка. Мы собираем только данные, необходимые для понимания спроса и, по вашему запросу, для связи по поводу дегустаций или наличия.`,
    collectTitle: "Что мы собираем",
    collectBody:
      "Вашу электронную почту, примерный район Дубая, предпочтения по воде и формату, реакцию на показанную цену, предполагаемую частоту покупок, тип покупателя, знакомство с Borsec, варианты согласия и базовую атрибуцию кампании. Мы не просим точный домашний адрес, гражданство, сведения о здоровье, платёжные данные или удостоверения личности.",
    useTitle: "Зачем мы это используем",
    useBody:
      "Чтобы измерить подтверждённый интерес, приглашать согласившихся участников на дегустации, понимать предпочтения по цене и формату и решить, стоит ли запускать соответствующий требованиям пилот поставок. Необязательное разрешение на журнал отделено от согласия на исследовательские контакты.",
    storageTitle: "Хранение и доступ",
    storageBody:
      `Ответы хранятся в базе ${cloudflareD1}. Уведомления о заявках отправляются только на подтверждённый адрес проекта. Исходные IP-адреса не сохраняются. Страна и код центра обработки данных Cloudflare могут храниться для общей оценки качества трафика.`,
    retentionTitle: "Срок хранения и ваш выбор",
    retentionBody:
      "Ответы исследования хранятся до 12 месяцев, если нет законной причины сохранить обезличенную сводку. Вы можете запросить доступ, исправление или удаление ответа либо отказаться от будущих писем, написав на",
    statusTitle: "Независимый статус",
    statusBody:
      "Проект не связан с Borsec или Romaqua Group и не одобрен ими. Если проект перейдёт коммерческому партнёру, это уведомление будет обновлено до использования данных для существенно иной цели."
  },
  notFound: {
    eyebrow: "404 · Не по маршруту",
    title: "Эта страница испарилась.",
    body: "Попробуйте исследование рынка, исследовательские материалы или журнал.",
    back: "Назад к SOURCE / SAND"
  },
  blog: {
    common: {
      minuteShort: "мин",
      minutes: (count) => {
        const mod10 = Math.abs(count) % 10;
        const mod100 = Math.abs(count) % 100;
        const unit =
          mod10 === 1 && mod100 !== 11
            ? "минута"
            : mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)
              ? "минуты"
              : "минут";
        return `${count.toLocaleString("ru-RU")} ${unit}`;
      },
      readNote: "Читать материал"
    },
    preview: {
      title: "Материалы о воде — без тумана велнеса.",
      intro:
        "Короткие тексты с источниками о минеральной воде, вкусе, водной системе Дубая и практическом пути от интереса к импорту.",
      readAll: "Все материалы",
      empty: "Опубликованных материалов о воде пока нет.",
      unavailable: "Переведённые материалы временно недоступны."
    },
    index: {
      title: "Вода из источника.",
      intro:
        "Минеральные этикетки, румынские источники, водная система Дубая, реалии импорта и вкус — со ссылками и без медицинского театра.",
      ruleLabel: "Редакционное правило 01",
      ruleBody: "Один поисковый вопрос. Одно возражение покупателя. Один честный следующий шаг.",
      read: "Читать"
    },
    article: {
      allNotes: "Все материалы",
      sourcesTitle: "Источники",
      sourcesIntro: "Основные материалы, использованные в статье. Последняя проверка",
      notFoundEyebrow: "404 · Материал не найден",
      notFoundTitle: "Этот материал о воде не найден.",
      notFoundBody: "Возможно, адрес устарел или черновик ещё не опубликован.",
      backToJournal: "Вернуться в журнал",
      outageEyebrow: "Соединение прервано",
      outageTitle: "Материал временно недоступен.",
      outageBody:
        "Проверьте соединение и повторите. Это не постоянный результат «не найдено».",
      tryAgain: "Повторить",
      loading: "Загружаем материал о воде…",
      visualsLabel: "Иллюстрация к статье"
    },
    categories: {
      "Mineral water": "Минеральная вода",
      "Dubai water": "Вода Дубая",
      "Import diary": "Дневник импорта",
      "Market case study": "Исследование рынка"
    }
  }
} satisfies MessageCatalog;
